import { faCircleStop } from "@fortawesome/pro-solid-svg-icons"
import { translate } from "app/language/service"
import { CAMPAIGN_STATUSES } from "campaign/model"
import { campaignRPO } from "campaign/repository"
import { messageSVC } from "message/service"
import { refreshCampaignList } from "./list"

export function cancelCampaign(campaignId: number, campaignName: string, isForecast: boolean): Promise<boolean> {
  return new Promise<boolean>((resolve, reject) => {
    messageSVC.confirmMessage({
      icon: faCircleStop,
      addGenericConfirmMessage: true,
      confirmButtonLabel: translate("button.stop"),
      title: translate("campaign.cancel.confirm.title"),
      message: translate("campaign.cancel.confirm.message", campaignName),
      onSuccess: async () => {
        try {
          await campaignRPO.update({ id: campaignId, status_id: CAMPAIGN_STATUSES.CANCELLED })
          refreshCampaignList({ isForecast, isDspDeal: false })
          resolve(true)
        } catch (error) {
          console.error(error)
          messageSVC.error(translate(""))
        }
      },
      onCancel: () => resolve(false)
    })
  })
}
